import type { ThemeDefinition } from "../types";
import { manifest } from "./theme.config";
import { slots } from "./components";

export const defaultTheme: ThemeDefinition = { manifest, slots };
